<div class="custom-overlay-container">
  <div class="custom-overlay-section">
    <mat-progress-spinner
      class="section-loader"
      [color]="color"
      [mode]="mode"
      [value]="value"
    >
    </mat-progress-spinner>
    <p class="loader-msg">Your data’s still loading, please wait.</p>
  </div>
</div>
